export const ACCESS_TOKEN_COOKIE = 'education-access-token';

// Export environment configuration
export {default as EnvConfig} from './env';
